import { Sun, Moon } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';

interface ThemeToggleProps {
  variant?: 'navbar' | 'header';
  className?: string;
}

export function ThemeToggle({ variant = 'header', className = '' }: ThemeToggleProps) {
  const { isDark, toggle } = useTheme();

  if (variant === 'navbar') {
    return (
      <button
        onClick={toggle}
        title={isDark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
        className={`w-10 h-10 min-w-[44px] min-h-[44px] md:w-8 md:h-8 md:min-w-0 md:min-h-0 rounded-full flex items-center justify-center bg-primary-foreground/10 border border-primary-foreground/20 hover:border-accent/40 text-foreground hover:text-accent transition-all duration-200 ${className}`}
      >
        {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
      </button>
    );
  }

  return (
    <button
      onClick={toggle}
      title={isDark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
      className={`inline-flex items-center justify-center w-9 h-9 rounded-lg border border-border bg-background hover:bg-accent/10 hover:border-accent/40 text-muted-foreground hover:text-accent transition-all duration-200 ${className}`}
    >
      {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
    </button>
  );
}
